import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { LoginContext } from "../../../../../services/api/authentication-api";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const TaskEditBottom = ({
  standardTask,
  setPanelVisibility,
  disableFields,
  isSubmitting,
  labels
}) => {
  const user = useContext(LoginContext);
  let history = useHistory();

  const goBack = () => {
    if (history.length > 1) {
      history.push("/tasks");
    } else {
      history.push("/dashboard");
    }
  };

  return (
    <div className="save-back-btn-container">
      <div className="save-back-btn">
        {
          <Button
            className="right-btn btn-wide btn-outlined"
            variant="primary"
            onClick={goBack}
          >
            Back
          </Button>
        }
        {!disableFields &&
        standardTask?.StatusAndButtons?.WorkflowButtons.includes("Cancel") ? (
          <Button
            title="Cancel"
            onClick={() =>
              setPanelVisibility((prev) => ({
                ...prev,
                showActionsPanel: 3,
              }))
            }
            className="right-btn btn-wide cancelColor"
            variant="primary"
          >
            Cancel {labels?.TaskSingular ?? 'Task'}
          </Button>
        ) : (
          <></>
        )}
        {!disableFields &&
        (standardTask?.StatusAndButtons?.WorkflowButtons.includes("Update") ||
          standardTask.CreatedById == user.userID ||
          standardTask.Permission === "Owner" ||
          standardTask.Permission === "Edit") &&
        !standardTask?.isArchived && (
          <Button
            type="submit"
            className="left-btn btn-wide"
            variant="primary"
            disabled={isSubmitting}
          >
            Update {labels?.TaskSingular ?? 'Task'}
          </Button>
        )}
        {!disableFields &&
          standardTask?.StatusAndButtons?.WorkflowButtons.includes(
            "Complete"
          ) && (
            <Button
              title="Complete Task"
              onClick={() =>
                setPanelVisibility((prev) => ({
                  ...prev,
                  showActionsPanel: 5,
                }))
              }
              className="right-btn btn-wide"
              variant="primary"
            >
              Complete {labels?.TaskSingular ?? 'Task'}
            </Button>
          )}
        {!disableFields &&
          standardTask?.StatusAndButtons?.WorkflowButtons.includes(
            "Decline"
          ) && (
            <Button
              title="Decline"
              onClick={() =>
                setPanelVisibility((prev) => ({
                  ...prev,
                  showActionsPanel: 1,
                }))
              }
              className="right-btn btn-wide"
              variant="primary"
            >
              Decline {labels?.TaskSingular ?? 'Task'}
            </Button>
          )}
        {!disableFields &&
          standardTask?.StatusAndButtons?.WorkflowButtons.includes(
            "Approve"
          ) && (
            <Button
              title="Approve"
              onClick={() =>
                setPanelVisibility((prev) => ({
                  ...prev,
                  showActionsPanel: 2,
                }))
              }
              className="right-btn btn-wide"
              variant="primary"
            >
              Approve {labels?.TaskSingular ?? 'Task'}
            </Button>
          )}
        {!disableFields &&
          standardTask?.StatusAndButtons?.WorkflowButtons.includes(
            "Request Review"
          ) && (
            <Button
              title="Request Review"
              onClick={() =>
                setPanelVisibility((prev) => ({
                  ...prev,
                  showActionsPanel: 4,
                }))
              }
              className="right-btn btn-wide request-review-btn"
              variant="primary"
            >
              Request Review
            </Button>
          )}
      </div>
    </div>
  );
};

export default TaskEditBottom;
TaskEditBottom.propTypes = {
  standardTask: PropTypes.object,
  setPanelVisibility: PropTypes.func,
  disableFields: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
};
